import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Globe, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-black tracking-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>SKOOP!</h3>
            <p className="text-white/70 text-sm leading-relaxed mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Your opinion matters. Powered by Intercept Insight, LLC — keeping the community's pulse on the community.
            </p>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <MapPin size={14} />
              <span>Avon, CO</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#38BDF8] mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Quick Links
            </h4>
            <div className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/services', label: 'Services' },
                { to: '/get-the-skoop', label: 'Get the SKOOP!' },
                { to: '/contact', label: 'Contact Us' },
              ].map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="block text-white/70 hover:text-[#38BDF8] transition-colors text-sm font-medium"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#38BDF8] mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Get in Touch
            </h4>
            <div className="space-y-3">
              <a
                href="https://www.skoopresearch.com"
                data-testid="footer-website-link"
                className="flex items-center gap-2 text-white/70 hover:text-[#38BDF8] transition-colors text-sm"
              >
                <Globe size={14} />
                www.skoopresearch.com
              </a>
              <a
                href="mailto:feedback@interceptinsight.com"
                data-testid="footer-email-link"
                className="flex items-center gap-2 text-white/70 hover:text-[#38BDF8] transition-colors text-sm"
              >
                <Mail size={14} />
                feedback@interceptinsight.com
              </a>
            </div>
          </div>
        </div>

        {/* Big SKOOP! */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-8xl sm:text-9xl font-black tracking-tighter text-white/5 select-none" style={{ fontFamily: 'Outfit, sans-serif' }}>
              SKOOP!
            </p>
            <p className="text-white/40 text-xs">
              &copy; {new Date().getFullYear()} SKOOP! by Intercept Insight, LLC. All rights reserved.
            </p>
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-white/20 hover:text-white/50 transition-colors text-xs">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
